import { getAEMPageUrl } from '@aem/utils';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { ContentPageId } from '@shared/models';
import { SKIP_URL_MUTATION } from '@shared/modules/http-request/context-tokens';
import { catchError, map, Observable, retry } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AEMService {
  constructor(private http: HttpClient) {}

  getContent<T>(url: string): Observable<T> {
    const context = new HttpContext().set(SKIP_URL_MUTATION, true);
    return this.http.get<T>(url, { context }).pipe(retry(1));
  }

  getFallbackContent<T>(pageId: ContentPageId): Observable<T> {
    const context = new HttpContext().set(SKIP_URL_MUTATION, true);
    const env = environment;
    return this.http
      .get<T>(`assets/fallback-content/${environment.aemEnv}/${pageId}.json`, { context })
      .pipe(retry(1));
  }

  getCommonContent<TRemoteContent, TMappedContent>(
    pageId: ContentPageId,
    mapper: (content: TRemoteContent) => TMappedContent,
  ): Observable<TMappedContent> {
    const url = getAEMPageUrl(pageId, environment.name);

    if (!url) {
      return this.getFallbackContent<TMappedContent>(pageId);
    }
    return this.getContent<TRemoteContent>(url).pipe(
      map((remoteContent) => mapper(remoteContent)),
      catchError(() => {
        return this.getFallbackContent<TMappedContent>(pageId);
      }),
    );
  }
}
